// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"b0f94d9a","63":"ee7ad81d","128":"8ff6729e","154":"3f2a2b92","251":"261870b4","280":"4d69418f","297":"87e7df30","299":"5a863e64","389":"e21e51dd","498":"c6aabd20","522":"6dbb2329","541":"05c84d7d","562":"34c04a60","652":"293041c4","672":"fd046419","995":"be778d63"}[chunkId] + ".chunk.js";
};